export type ORIGIN_URL = string;

export const isTopWindow = () => window.self === window.top;

export const childrenDomainBuilder = (domains: ORIGIN_URL[]) => {
  return domains.filter((it) => it !== window.location.origin);
};
